// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout-module--layout--2CAqk","storage":"layout-module--storage--1N0M7"};